import type { PointData } from 'pixi.js';
import { Container } from 'pixi.js';
import { getLocalizedValue } from '@softgames/localization';
import { WinStreakPlayerLayout } from '../../../../layouts/winStreak/WinStreakPlayerLayout';
import { TileFlipAnimator } from '../../../game/boardMVC/views/board/TileFlipAnimator';

export class WinStreakPlayerView extends Container {
  private readonly layout = new WinStreakPlayerLayout();

  private readonly animator = new TileFlipAnimator(this);

  constructor(levelNumber: number) {
    super();

    this.interactiveChildren = false;

    this.layout.root.props({ parent: this });
    this.layout.levelText.text = getLocalizedValue(levelNumber);
    this.layout.levelText.visible = levelNumber !== 0;
  }

  public async hideLevelNumber(): Promise<void> {
    await this.layout.levelText.tweenTo({ scaleXY: 0 }, 300, 'disappear1', true).asyncOnComplete();
  }

  public async showLevelNumber(levelText: number): Promise<void> {
    this.layout.levelText.visible = levelText !== 0;
    this.layout.levelText.text = getLocalizedValue(levelText);
    await this.layout.levelText.tweenTo({ scaleXY: 1 }, 300, 'appear1', true).asyncOnComplete();
  }

  public async jump(toPos: PointData): Promise<void> {
    await this.animator.animateFromTo(this, this.layout.tile, toPos);
  }
}
